import Invoices from "@features/invoices/pages/invoices";
import InvoicesList from "@features/invoices/components/InvoicesList";
import InvoicesDetails from "@features/invoices/pages/InvoicesDetails";
import CreateInvoice from "@features/invoices/components/CreateInvoice";

export const invoicesRoutes = {
  path: "/invoices",
  element: <Invoices />,
  children: [
    {
      path: "/invoices",
      element: <InvoicesList />,
    },
    {
      path: "/invoices/:id",
      element: <InvoicesDetails />,
    },
    {
      path: "/invoices/create",
      element: <CreateInvoice />,
    },
  ],
};
